import React from "react";
import {SortDirection, type SortStrategy} from "../configuration/list/constants";

interface SortIconProps {
  currentStrategy: SortStrategy;
  headerStrategy: SortStrategy;
  direction: SortDirection;
}

export const SortIcon = ({currentStrategy, headerStrategy, direction}: SortIconProps) =>
  currentStrategy === headerStrategy ? (
    <span aria-hidden="true" className="float-end sort-icon">
      <span className="float-end">{SortDirectionMap[direction] ?? null}</span>
    </span>
  ) : (
    <span aria-hidden="true" className="float-end sort-icon">
      <span className="float-end">
        <SortDirectionNone />
      </span>
    </span>
  );

const SortDirectionNone = () => <i className="fal fa-sort"></i>;

const SortDirectionMap = {
  [SortDirection.NONE]: <SortDirectionNone />,
  [SortDirection.ASCENDING]: <i className="fas fa-caret-up"></i>,
  [SortDirection.DESCENDING]: <i className="fas fa-caret-down"></i>
};
